<template>
  <div class="home__content home-frontpage">
    <router-link
      v-if="unreadWatchlistDocumentsCount"
      :to="{ name: routeWatchlistName }"
      class="home__header frontpage__watchlist"
    >
      <span class="frontpage__watchlist-count">
        {{ unreadWatchlistDocumentsCount }}
      </span>
      непрочитанных документов на контроле
    </router-link>

    <frontpage-recent
      class="frontpage__section frontpage__recent"
      :recentDocs="recentDocuments"
      :titleStyle="'frontpage__title'"
    />

    <frontpage-useful 
      class="frontpage__section frontpage__useful"
      :links="availableUsefulLinks"
      :titleStyle="'frontpage__title'"
    />

    <normacs-info  class="frontpage__section frontpage__normacsinfo"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import apiApp from '@src/api/app';
import apiUser from '@src/api/user';

import { RECENT_DOCUMENTS_PERIOD_ALL } from '@src/api/user';

import FrontpageRecent from './FrontpageRecent';
import FrontpageUseful from './FrontpageUseful';
import NormacsInfo from './NormacsInfo';

export default {
  components: {
    FrontpageRecent,
    FrontpageUseful,
    NormacsInfo
  },

  data: () => ({
    banners: [],
    usefulLinks: [],
    recentDocuments: null,
    routeWatchlistName: 'watchlist'
  }),

  computed: {
    ...mapGetters({
      hasInternet: 'hasInternet',
      unreadWatchlistDocumentsCount: 'watchlistUnreadDocumentsTotal'
    }),
    availableUsefulLinks() {
      if (this.hasInternet) {
        return this.usefulLinks;
      }
      return this.usefulLinks.filter(link => link.internal);
    },
    banner() {
      return this.banners[0];
    }
  },

  async created() {
    try {
      let recentDocsPromise = apiUser.getRecentDocuments(RECENT_DOCUMENTS_PERIOD_ALL, 4, 0, false)
      let userInfoPromise = apiApp.getUsefulInfo()

      await this.$store.dispatch('countUnreadWatchlistDocuments')
      let docsData = await recentDocsPromise
      let userData = await userInfoPromise

      this.recentDocuments = docsData.items
      this.banners = userData.banners
      this.usefulLinks = userData.links
    } catch(err){
      console.error(`Error on get fronpage info with: ${err.message}`)
    }
  },

  metaInfo: {
    title: 'Главная страница'
  }
};
</script>
